import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class UserService {
    getAllUser() {
        return axios.get(API_URL+'user', { headers: authHeader() });
    }
    getAllManager() {
        return axios.get(API_URL+'manager-list', { headers: authHeader() });
    }
    getProfile() {
        return axios.get(API_URL+'user-profile', { headers: authHeader() });
    }
    updateProfile(data) {
        return axios.patch(API_URL + 'user-profile', data, {
            headers: authHeader() });
    }
    getEditUser(id) {
        return axios.get(API_URL+'user/'+id, { headers: authHeader() });
    }
    updateUser(id, data) {
        return axios.patch(API_URL + 'user/' + id, data, {
            headers: authHeader() });
    }
    addUser(data) {
        return axios.post(API_URL + 'user', data, {
            headers: authHeader() });
    }
    deleteUser(id) {
        return axios.delete(API_URL+'user/'+id, {
            headers: authHeader()
        });
    }
    updatePassword(id, data) {
        return axios.patch(API_URL + 'user/change-password/' + id, data, {
            headers: authHeader() });
    }
    updateUserAvatar(data) {
        return axios.post(API_URL + 'user-profile/change-avatar', data, {headers: authHeader() });
    }
    changePassword(data) {
        return axios.post(API_URL + 'user-profile/change-password', data, {headers: authHeader() });
    }
}

export default new UserService();
